import { Component, Input, OnInit } from '@angular/core'
import { Observable } from 'rxjs'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { ProviderInfo } from 'src/app/obstacle/model/provider-info.model'
import { Layers } from 'src/app/shared/layers-config/layers'

const COLLAPSED_STORAGE_KEY = 'obstacle-provider9-data-collapsed'

@Component({
  selector: 'app-obstacle-provider9-data',
  templateUrl: './obstacle-provider9-data.component.html',
  standalone: false,
})
export class ObstacleProvider9DataComponent implements OnInit {
  public layerIds = Layers
  public isConstructionSitesLayerVisible: boolean | undefined
  public isStoppedVehicleLayerVisible: boolean | undefined
  public isCollapsed = true
  @Input() providerInfo$!: Observable<ProviderInfo>

  constructor(private appState: AppStateService) {
    const layers = this.appState.selectLayers()
    this.isConstructionSitesLayerVisible = layers?.some(
      (layer) => layer === Layers.Provider9Cs.name,
    )
    this.isStoppedVehicleLayerVisible = layers?.some((layer) => layer === Layers.Provider9Sv.name)
  }

  ngOnInit(): void {
    this.isCollapsed = this.getStoredCollapsedState()
  }

  get selectedLayerCount(): number {
    return [this.isConstructionSitesLayerVisible, this.isStoppedVehicleLayerVisible].filter(Boolean)
      .length
  }
  get allLayerCount(): number {
    return [this.isConstructionSitesLayerVisible, this.isStoppedVehicleLayerVisible].length
  }

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed
    this.storeCollapsedState()
  }

  toggleLayerVisbility(layerId: string) {
    switch (layerId) {
      case Layers.Provider9Cs.name:
        this.isConstructionSitesLayerVisible = !this.isConstructionSitesLayerVisible
        break
      case Layers.Provider9Sv.name:
        this.isStoppedVehicleLayerVisible = !this.isStoppedVehicleLayerVisible
        break
      default:
        break
    }
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    const layers = this.appState
      .selectLayers()
      .filter((layer) => !(layer == Layers.Provider9Cs.name) && !(layer == Layers.Provider9Sv.name))
    if (this.isConstructionSitesLayerVisible) {
      layers.push(Layers.Provider9Cs.name)
    }

    if (this.isStoppedVehicleLayerVisible) {
      layers.push(Layers.Provider9Sv.name)
    }

    this.appState.setState(AppPaths.Obstacle, {
      layers: layers?.toString(),
    })
  }

  private getStoredCollapsedState(): boolean {
    if (typeof localStorage === 'undefined') {
      return true
    }

    const storedState = localStorage.getItem(COLLAPSED_STORAGE_KEY)

    if (storedState === null) {
      return true
    }

    return storedState === 'true'
  }

  private storeCollapsedState(): void {
    if (typeof localStorage === 'undefined') {
      return
    }

    localStorage.setItem(COLLAPSED_STORAGE_KEY, String(this.isCollapsed))
  }
}
